import { EntityDialog, AddBtn, IconBtn } from "@/components/admin/shared";
import { Pencil, Trash2, Sparkles, Eye, EyeOff, Instagram, Share2, MessageCircle, Loader2 } from "lucide-react";

export default function ArticlesPanel({
  articles, articleFields, saveArticle, togglePublish, postToIg, igKitManual,
  generateDrafts, genLoading, autoCats, toggleAutoCat, AUTO_OPTIONS, del, setArticles,
}) {
  return (
    <>
      {/* AI monthly draft generation */}
      <div className="mb-5 rounded-sm border border-legend-red/40 bg-legend-red/5 p-4" data-testid="ai-generation-panel">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <p className="font-display font-bold uppercase text-sm flex items-center gap-2"><Sparkles size={16} className="text-legend-red" /> Notizie automatiche (IA)</p>
            <p className="text-xs text-slate-500 mt-1 max-w-xl">Ogni mese (il 25) l'IA prepara delle <strong>bozze</strong> sugli eventi delle zone di Rimini e Forlì-Cesena e sui risultati europei. Le bozze non sono pubblicate finché non le approvi tu. Scegli gli argomenti:</p>
            <div className="flex flex-wrap gap-2 mt-3">
              {AUTO_OPTIONS.map((o) => (
                <button key={o.key} onClick={() => toggleAutoCat(o.key)} data-testid={`auto-cat-${o.key}`}
                  className={`text-xs font-semibold px-3 py-1.5 rounded-sm border transition-colors ${autoCats.includes(o.key) ? "bg-legend-red text-white border-legend-red" : "bg-white dark:bg-legend-paper border-slate-300 dark:border-slate-700"}`}>
                  {o.label}
                </button>
              ))}
            </div>
          </div>
          <button onClick={generateDrafts} disabled={genLoading} data-testid="generate-drafts-btn"
            className="inline-flex items-center gap-2 bg-legend-ink text-white text-sm font-bold uppercase px-4 py-2.5 rounded-sm hover:bg-slate-800 disabled:opacity-60">
            {genLoading ? <Loader2 size={15} className="animate-spin" /> : <Sparkles size={15} />} Genera bozze ora
          </button>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <EntityDialog title="Nuovo articolo" fields={articleFields} initial={{ category: "Rally & Gare", author: "Redazione Legend Magazine", read_time: 4, featured: false, published: true, gallery: [], related_slugs: [] }} onSave={saveArticle} trigger={<AddBtn data-testid="add-article-btn" />} />
      </div>
      <div className="space-y-2">
        {articles.map((a) => {
          const isDraft = a.published === false;
          return (
          <div key={a.id} className={`flex items-center gap-3 p-3 rounded-sm border bg-white dark:bg-legend-paper ${isDraft ? "border-amber-400" : "border-slate-200 dark:border-slate-800"}`}>
            {a.cover_image ? <img src={a.cover_image} alt="" className="w-16 h-12 object-cover rounded-sm" /> : <div className="w-16 h-12 rounded-sm bg-slate-100 dark:bg-white/5" />}
            <div className="flex-1 min-w-0">
              <p className="font-display font-bold uppercase text-sm truncate flex items-center gap-2">
                {a.title}
                {isDraft && <span className="text-[9px] bg-amber-400 text-legend-ink px-1.5 py-0.5 rounded-sm">BOZZA</span>}
                {a.ai_generated && <span className="text-[9px] bg-legend-ink text-white px-1.5 py-0.5 rounded-sm">IA</span>}
              </p>
              <p className="text-xs text-slate-500">{a.category} {a.featured && "· ⭐ In evidenza"} {a.title_en && "· 🌐 EN"} {a.instagram_media_id && "· 📷 IG"}</p>
            </div>
            <IconBtn data-testid={`ig-kit-${a.id}`} title="Kit post manuale: copia didascalia + scarica immagine" onClick={() => igKitManual(a)}><Share2 size={15} /></IconBtn>
            <a
              href={`https://wa.me/393791222217?text=${encodeURIComponent(`${a.title}\n${process.env.REACT_APP_BACKEND_URL}/api/share/${a.slug}`)}`}
              target="_blank"
              rel="noreferrer"
              data-testid={`wa-publish-${a.id}`}
              title="Pubblica su WhatsApp (+39 379 1222217)"
              className="inline-grid place-items-center w-8 h-8 rounded-sm border border-slate-300 dark:border-slate-700 text-[#25D366] hover:bg-[#25D366] hover:text-white hover:border-[#25D366] transition-colors"
            >
              <MessageCircle size={15} />
            </a>
            <IconBtn data-testid={`ig-post-${a.id}`} title="Pubblica su Instagram (automatico, richiede collegamento)" onClick={() => postToIg(a)}><Instagram size={15} /></IconBtn>
            <IconBtn data-testid={`toggle-publish-${a.id}`} title={isDraft ? "Pubblica" : "Sposta in bozze"} onClick={() => togglePublish(a)}>{isDraft ? <Eye size={15} /> : <EyeOff size={15} />}</IconBtn>
            <EntityDialog title="Modifica articolo" fields={articleFields} initial={{ ...a, gallery: a.gallery || [], related_slugs: a.related_slugs || [] }} onSave={saveArticle} trigger={<IconBtn data-testid={`edit-article-${a.id}`}><Pencil size={15} /></IconBtn>} />
            <IconBtn data-testid={`delete-article-${a.id}`} onClick={() => del("/admin/articles", a.id, setArticles, articles)}><Trash2 size={15} /></IconBtn>
          </div>
          );
        })}
      </div>
    </>
  );
}
